import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../lib/constants';
import { Hero } from './Hero/Hero';
import { BusinessPackages } from './Packages/BusinessPackages';
import { Difference } from './Difference/Difference';
import { HowItWorks } from './HowItWorks/HowItWorks';
import { FAQAccordion } from './FAQ/FAQAccordion';
import { BusinessInquiryForm } from './InquiryForm/BusinessInquiryForm';

export const BusinessSolutions = (): React.JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>{ROUTES.businessSolutions.title}</title>
        <meta
          name="description"
          content="Fast, reliable business internet with local support you can count on. Explore Cityside Fiber's business internet packages built for SoCal businesses."
        />
        <meta property="og:title" content={ROUTES.businessSolutions.title} />
        <meta
          property="og:description"
          content="Fast, reliable business internet with local support you can count on. Explore Cityside Fiber's business internet packages built for SoCal businesses."
        />
        <link rel="canonical" href="https://www.citysidefiber.com/business" />
        <meta property="og:url" content="https://www.citysidefiber.com/business" />
      </Helmet>

      <Hero />
      <BusinessPackages />
      <Difference />
      <HowItWorks />
      <FAQAccordion />
      <BusinessInquiryForm />
    </>
  );
};
